<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <div>
                <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                    <div class="kgr-postfix__fluid">
                        <kgr-view-picker
                            :value="view"
                            @post-input="updateView"
                        />
                    </div>
                    <div
                        v-if="canCreateNew"
                        class="kgr-postfix__fixed"
                    >
                        <a
                            class="kgr-button kgr-button--accent"
                            :href="createUrl"
                        >
                            <kgr-icon
                                icon-class="add"
                                small
                                circle
                                highlight
                                class="kgr-button__icon kgr-button__icon--left"
                            />
                            <span v-t="'location.create'"></span>
                        </a>
                    </div>
                    <div class="kgr-postfix__fixed">
                        <kgr-print-button />
                    </div>
                </div>

                <div class="kgr grid kgr-grid--inline kgr-grid--gutters kgr-row">
                    <div class="kgr-grid__cell">
                        <label class="kgr-inputGroup">
                            <div
                                v-t="'search'"
                                class="kgr-inputGroup__label"
                            ></div>
                            <input
                                v-model="filter"
                                type="text"
                                class="kgr-input"
                            />
                        </label>
                    </div>
                </div>
            </div>

            <div>
                <kgr-locations-list
                    :locations="locations"
                    :filter="filter"
                    :view="view"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '../../components/common/icon/Icon';
import KgrLocationsList from '../../components/resource/LocationsList';
import LocationRepository from '../../js/repository/LocationRepository';
import PrintButton from '../../components/common/form/button/PrintButton';
import ViewPicker from '../../components/common/form/picker/ViewPicker';

const LOCATIONS_OVERVIEW_VIEW = 'kgr:locations:overview:view';

export default {
    components: {
        'kgr-locations-list': KgrLocationsList,
        'kgr-print-button': PrintButton,
        'kgr-view-picker': ViewPicker,
        'kgr-icon': Icon,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        createUrl: {
            type: String,
            required: true,
        },
        canCreateNew: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            filter: null,
            locations: [],
            view: 'grid'
        };
    },
    created() {
        const view = localStorage.getItem(LOCATIONS_OVERVIEW_VIEW);
        if (null !== view && '' !== view) {
            this.view = view;
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        updateView(view) {
            this.view = view;

            if (null !== view) {
                localStorage.setItem(LOCATIONS_OVERVIEW_VIEW, view);
            } else {
                localStorage.removeItem(LOCATIONS_OVERVIEW_VIEW);
            }
        },
        load() {
            LocationRepository.findAll()
                .then(locations => this.locations = locations)
                .catch(() => this.$notify.error('error.loadingData'));
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
